import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/stocks'
export default {
  namespaced: true,
  state: {
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      scode: null,
      title: null,
      notes: null,
      min_amount: null,
      max_amount: null,
      amount: null,
      amountPrice: null,
      currencies: null,
      id_stock_groups: null,
      id_units: null,
      id_users: null,
      submitData: false,
    },
    filterData: {
      keywords: null,
      id_stock_groups: null,
      id_users: null,
      detailSearch: false,
    },
    dataLoading: false,
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    filterData(state) {
      return state.filterData
    },
    dataLoading(state) {
      return state.dataLoading
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        scode: null,
        title: null,
        notes: null,
        min_amount: null,
        max_amount: null,
        amount: null,
        amountPrice: null,
        currencies: null,
        id_stock_groups: null,
        id_units: null,
        id_users: null,
        submitData: false,
      }
    },
    SET_DATA_LOADING(state, status) {
      state.dataLoading = status
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('SET_DATA_LOADING', true)
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LOADING', false)
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, id) {
      commit('SET_DATA_LOADING', true)
      const data = JSON.stringify({
        where: {
          'stocks.id': id,
        },
        array: false,
      })
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LOADING', false)
          commit('SET_DATA_ITEM', response.data.data)
        })
        .catch(error => console.error(error))
    },
    getDataItem2({ commit }, id) {
      commit('SET_DATA_LOADING', true)
      const data = JSON.stringify({
        where: {
          'stocks.id': id,
        },
        array: false,
      })
      return axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LOADING', false)
          commit('SET_DATA_ITEM', response.data.data)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
